import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TopbarContractor } from "./TopbarContractor";
import styles from "./ContractorLayout.module.css";
export const ContractorLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.container, children: [_jsx(TopbarContractor, {}), _jsx("main", { className: styles.mainContent, children: children })] }));
};
